// @ts-nocheck
import React, {useState} from 'react';
import Text from '../components/Text';

interface DragDropImageContainerProps {
  value?: string | null;
  onChange: (base64: string) => void;
  height?: number;
  label?: string;
}

const DragDropImageContainer = ({
  value,
  onChange,
  height = 256,
  label = 'Drag & drop image here',
}: DragDropImageContainerProps) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const file = e.dataTransfer.files?.[0];
    if (!file || !file.type.startsWith('image/')) return;

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = event => {
      const data = event.target?.result as string;
      onChange(data.split(',')[1]);
    };
  };

  return (
    <div
      onDragOver={e => {
        e.preventDefault();
        setIsDragging(true);
      }}
      onDragLeave={() => setIsDragging(false)}
      onDrop={handleDrop}
      style={{
        height,
        border: '2px dashed',
        borderColor: isDragging ? '#2563EB' : '#ccc',
        borderRadius: 8,
        backgroundColor: isDragging ? '#EFF6FF' : '#f9f9f9',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.15s ease',
      }}
      /* ===== DRAG EVENTS ===== */
      onDrag={e => console.log('drag', e)}
      onDragStart={e => {
        console.log('dragstart', e);
        setIsDragging(true);
      }}
      onDragEnter={e => {
        console.log('dragenter', e);
       e.preventDefault();
        setIsDragging(true);
      }}
      onDragOver={e => {
        console.log('dragover', e);
        e.preventDefault();
      }}
      onDragLeave={e => {
        console.log('dragleave', e);
        setIsDragging(false);
      }}
      onDrop={e => {
        console.log('drop', e);
        e.preventDefault();
        setIsDragging(false);

        const file = e.dataTransfer?.files?.[0];
        if (!file) {
          console.warn('[DND] No file detected');
          return;
        }

        console.log('[DND] File:', file.name, file.type);

        const reader = new FileReader();
        reader.onload = ev => {
          const data = ev.target?.result as string;
          onChange(data.split(',')[1]);
        };
        reader.readAsDataURL(file);
      }}
      >
      {value ? (
        <img
          src={`data:image/jpeg;base64,${value}`}
          style={{
            maxHeight: '98%',
            maxWidth: '98%',
            borderRadius: 8,
          }}
        />
      ) : (
        <Text style={{fontSize: 16, color: '#6B7280'}}>
          {label}
        </Text>
      )}
    </div>
  );
};

export default DragDropImageContainer;
